<template>
  <div
    ref="table"
    class="c-table"
    :class="{
      'c-table_scrolled': isScrolled,
      'c-table_scrolled_right': !isScrollEnd && !data.actions && isScroll,
      'c-table_scroll_end': isScrollEnd,
      'c-table_scroll': isScroll,
    }"
  >
    <div
      v-if="shouldDisplayRecord"
      :class="{
        'c-table__shadow': data.actions,
        'c-table__shadow__finance': data.type === 'finance',
        'c-table__shadow__inventory-items-positions': data.type === 'inventory-items-positions',
        'c-table__shadow__documents': data.type === 'documents-archive' || data.type === 'documents-acting-documents',
        'c-table__shadow_active': data.actions,
        // 'c-table__empty__shadow': data.isGroupByCategory && hideCollapseGroups.length === data.records.length
      }"
    ></div>
    <div v-if="isScroll" class="c-table__scrollbar-wrapper"></div>

    <perfect-scrollbar :ref="'wrapper' + (id !== undefined ? id : '')" class="c-table__wrapper" @scroll="scroll">
      <table ref="container" class="c-table__container">
        <thead ref="header" class="c-table__header">
          <tr v-for="i in levels" :key="i" class="c-table__header-row">
            <th
              v-for="column in getTableColumns(i)"
              :id="`c-table-column-${column.id}`"
              :key="column.id"
              class="c-table__column"
              :style="{ width: column.width ? column.width : '' }"
              :colspan="column.colspan === undefined ? getColspan(column) : column.colspan"
              :rowspan="getRowspan(column)"
              :class="{
                'c-table__column_with_filter': column.type,
                'c-table__column_hidden': isDisabled(column.id),
                'c-table__column_sorted': isSorted(column),
              }"
            >
              <div class="c-table__column-wrapper">
                <div
                  class="c-table__column-label"
                  :class="{ 'c-table__column-label-children': !isCategory(column) && sortedColumn }"
                  @click="setSortedColumn(column, sortedColumn)"
                >
                  {{ column.label }}
                </div>

                <div v-if="column.description || column.type" class="c-table__column-actions">
                  <div v-if="column.fullName" class="c-table__column-action c-table__column-action_description">
                    <c-button :id="`table-column-button-description-${column.id}`" size="small" icon="info" no-border />

                    <b-popover
                      placement="top"
                      triggers="hover"
                      :target="`table-column-button-description-${column.id}`"
                    >
                      {{ column.fullName }}
                    </b-popover>
                  </div>

                  <div v-if="isColumnFiltered(column.id)" class="c-table__column-action">
                    <c-button
                      :id="`table-column-button-filter-${column.id}`"
                      size="small"
                      no-border
                      :active="isColumnActiveFiltered(column.id)"
                      :icon="{
                        icon: 'filter-column',
                        activeColor: 'blue',
                      }"
                      @click="openColumnFilterModal(column)"
                    />

                    <b-popover placement="top" triggers="hover" :target="`table-column-button-filter-${column.id}`">
                      {{ isColumnActiveFiltered(column.id) ? "Изменить фильтр" : "Применить фильтр" }}
                    </b-popover>
                  </div>
                </div>
              </div>
            </th>

            <th
              v-if="data.actions && i === 1"
              id="c-table-actions-element"
              class="c-table__column c-table__column_actions"
              :rowspan="levels"
            >
              <div class="c-table__column-empty"></div>
            </th>
          </tr>
        </thead>

        <tbody v-if="!data.isGroupByCategory" class="c-table__records">
          <tr
            v-for="(record, recordIndex) in sortedRecords"
            v-show="record.isShowRow"
            :key="recordIndex"
            class="c-table__record"
            :class="{
              'c-table__record__red':
                (data.type === 'discipline' &&
                  (record.explanatory.value === 'need_write' ||
                    record.explanatory.value === 'expired' ||
                    record.explanatory.value === 'issued_fine')) ||
                (data.type === 'inventory-items-positions' && record.status.desc === 'issuedoverdue'),
              'c-table__record__yellow':
                data.type === 'inventory-items-positions' && record.status.desc === 'notissued',
              'c-table__record__grey': record.isSumRow !== undefined && record.isSumRow,
            }"
          >
            <template v-for="(column, cellIndex) in getTableColumns(levels)">
              <td
                :key="`cell-${cellIndex}`"
                class="c-table__cell"
                :style="{
                  'background-color':
                    column.id === 'fotFromProceeds' || column.id === 'fotInCategory' || column.id=='productionRate' ? getColorForPercentage(record[column.id].value, column.id) : '',
                }"
                :class="{
                  // 'c-table__cell__red': (column.id === 'fotFromProceeds' || column.id === 'fotInCategory') && record[column.id].value < 50,
                  // 'c-table__cell__green': (column.id === 'fotFromProceeds' || column.id === 'fotInCategory') && record[column.id].value > 50,
                  'c-table__cell_string': column.type === 'string',
                  'c-table__cell_reference': column.type === 'reference',
                  'c-table__cell_number': column.type === 'number',
                  'c-table__cell_date': column.type === 'date',
                  'c-table__cell_hidden': isDisabled(column.id),
                  'c-table__cell_double_top_border': record.isSumRow !== undefined && record.isSumRow,
                  ['c-table__cell_' + column.id]: column.id,
                }"
              >
                <c-table-load-cell v-if="column.id === 'load'" :record="record" @loadvalue="loadvalue"/>
                <c-table-additional-load-cell v-else-if="column.id === 'additionalLoad'" :record="record"
                @salmon="salmon"
                />
                <c-table-lateness-cell v-else-if="column.id === 'lateness'" :calc-data="calcData" :record="record" />
                <div v-else class="c-table__cell-value" v-html="record[column.id].value">
                  {{ record[column.id].value }}
                </div>
              </td>
              <td
                v-for="rec in record[column.id].values"
                :key="`${rec.value}-record`"
                class="c-table__cell"
                :rowspan="rec.rowspan"
                :class="{
                  'c-table__cell_string': column.type === 'string',
                  'c-table__cell_reference': column.type === 'reference',
                  'c-table__cell_number': column.type === 'number',
                  'c-table__cell_date': column.type === 'date',
                  'c-table__cell_hidden': isDisabled(column.id),
                  'c-table__cell_vertical_align':
                    data.type === 'main-factors' && record[column.id].values[0].countIntervals,
                  ['c-table__cell_' + column.id]: column.id,
                }"
              >
                <div
                  v-if="record[column.id] && record[column.id].values && rec.value"
                  class="c-table__cell-values"
                  v-html="rec.value"
                >
                  {{ rec.value }}
                </div>
              </td>
            </template>
            <td v-if="data.actions" class="c-table__cell c-table__cell_actions">
              <div class="c-table__cell-actions">
                <c-table-main-factors-actions v-if="data.type === 'main-factors'" :record="record" />
                <c-table-finance-actions v-if="data.type === 'finance'" :record="record" />
                <c-table-inventory-items-actions v-if="data.type === 'inventory-items-positions'" :record="record" />
              </div>
            </td>
          </tr>
        </tbody>

        <tbody
          v-for="(group, groupIndex) in sortedRecords"
          :key="`${groupIndex}-records-group`"
          class="c-table__records"
        >
          <template v-if="data.isGroupByCategory">
            <tr v-b-toggle="`category-collapse-${id}-${groupIndex}`" class="c-table__record">
              <th
                :style="{
                  'border-bottom': sortedRecords.length === groupIndex + 1 ? 'solid 1px #DFE4EF !important' : '',
                }"
                class="c-table__cell__collapse__button"
                :class="{
                  'c-table__cell__collapse__button__docs':
                    data.type === 'documents-acting-documents' || data.type === 'documents-archive',
                }"
                :colspan="getTableColumns(levels).length + (data.actions ? 1 : 0)"
              >
                <svg
                  class="c-table__cell__collapse__button__icon"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="11" cy="11" r="10.5" fill="white" stroke="#DFE4EF" />
                  <path
                    d="M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z"
                    fill="#0066FF"
                  />
                  <path
                    d="M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z"
                    fill="#0066FF"
                  />
                </svg>
                <span class="c-table__cell__collapse__button__category__name">{{ group.categoryName }}</span>
                <span
                  v-if="data.type === 'documents-acting-documents' || data.type === 'documents-archive'"
                  class="c-table__cell__collapse__button__category__count"
                >
                  {{ group.records.length }}
                </span>
                <div class="c-table__cell__collapse__button__border__right"></div>
              </th>
            </tr>
            <b-collapse
              v-for="(record, recordIndex) in group.records"
              v-show="record.isShowRow"
              :id="`category-collapse-${id}-${groupIndex}`"
              :key="recordIndex"
              tag="tr"
              class="c-table__record"
              visible
            >
              <template v-if="record.isShowRow">
                <td
                  v-for="(column, cellIndex) in getTableColumns(levels)"
                  :key="`${column.id}-${cellIndex}`"
                  class="c-table__cell"
                  :class="{
                    'c-table__cell_string': column.type === 'string',
                    'c-table__cell_reference': column.type === 'reference',
                    'c-table__cell_number': column.type === 'number',
                    'c-table__cell_date': column.type === 'date',
                    'c-table__cell_hidden': isDisabled(column.id),
                    ['c-table__cell_' + column.id]: column.id,
                  }"
                >
                  <div class="c-table__cell-value" v-html="record[column.id].value">{{ record[column.id].value }}</div>
                </td>
                <td v-if="data.actions" class="c-table__cell c-table__cell_actions">
                  <div class="c-table__cell-actions">
                    <c-table-inventory-items-actions
                      v-if="data.type === 'inventory-items-positions'"
                      :record="record"
                    />
                    <c-table-documents-actions
                      v-if="data.type === 'documents-acting-documents' || data.type === 'documents-archive'"
                      :record="record"
                      :record-id="`${groupIndex}-${recordIndex}`"
                      :table-type="data.type"
                    />
                  </div>
                </td>
              </template>
            </b-collapse>
          </template>
        </tbody>
      </table>
    </perfect-scrollbar>

    <div v-if="data.records.length === 0" class="c-table__empty__records">{{ emptyRecordsLabel }}</div>

    <div v-if="!data.isGroupByCategory && data.records.length > 0" class="c-table__container__mobile">
      <div :id="'tableMobileFixed' + id" class="c-table__container__mobile__fixed__th">
        <table ref="container">
          <template v-for="(column, recordIndex) in getColumns(data.levels)">
            <tr v-if="column.colspan === 1" :key="`${recordIndex}-column`" class="c-table__record">
              <th
                :class="{
                  'c-table__column_sorted': isSorted(column),
                }"
                class="c-table__column c-table__column__mobile"
              >
                <div
                  :class="{
                    'c-table__column-wrapper-mobile-main-factors': data.type === 'main-factors',
                    'c-table__column-wrapper-mobile-finance': data.type === 'finance',
                  }"
                  class="c-table__column-wrapper c-table__column-wrapper-mobile"
                  @click="setSortedColumn(column, sortedColumn)"
                >
                  <div class="c-table__column-label" :class="`c-table__column-label-${column.id}`">
                    {{ column.label }}
                  </div>
                </div>
              </th>
              <template v-for="(record, recordIndex) in sortedRecords">
                <td
                  :key="recordIndex"
                  :class="{
                    'c-table__cell__border__none': sortedRecords.length - 1 === recordIndex,
                    'c-table__cell__move__in__company': data.type === 'move-in-company',
                    'c-table__cell__red':
                      (column.id === 'fotFromProceeds' || column.id === 'fotInCategory') && record[column.id] < 50,
                    'c-table__cell__green':
                      (column.id === 'fotFromProceeds' || column.id === 'fotInCategory') && record[column.id] > 50,
                  }"
                  class="c-table__cell"
                >
                  <c-table-load-cell v-if="column.id === 'load'" :record="record" />
                  <c-table-additional-load-cell v-else-if="column.id === 'additionalLoad'" :record="record" />
                  <c-table-lateness-cell v-else-if="column.id === 'lateness'" :calc-data="calcData" :record="record" />
                  <div v-else class="c-table__cell-value" v-html="record[column.id].value">
                    {{ record[column.id].value }}
                  </div>
                </td>
              </template>
            </tr>
            <tr v-for="(row, ind) in column.colspan" :key="`${recordIndex}-${ind}-rows`" class="c-table__record">
              <template v-if="column.colspan > 1">
                <th v-if="ind === 0" :rowspan="column.colspan" class="c-table__column c-table__column__mobile">
                  <div
                    :class="{
                      'c-table__column-wrapper-mobile-main-factors': data.type === 'main-factors',
                      'c-table__column-wrapper-mobile-finance': data.type === 'finance',
                    }"
                    class="c-table__column-wrapper c-table__column-wrapper-mobile"
                  >
                    <div class="c-table__column-label" :class="`c-table__column-label-${column.id}`">
                      {{ column.label }}
                    </div>
                  </div>
                </th>
                <template v-for="(record, recordIndex) in sortedRecords">
                  <td
                    v-if="record[column.id].values[row - 1].value"
                    :key="`${recordIndex}-record-row`"
                    :colspan="record[column.id].values[row - 1].rowspan"
                    :class="{
                      'c-table__cell__border__none': sortedRecords.length - 1 === recordIndex,
                    }"
                    class="c-table__cell"
                  >
                    <div
                      :class="{ 'c-table__cell-value-nowrap': data.type === 'main-factors' }"
                      class="c-table__cell-values"
                      v-html="record[column.id].values[row - 1].value"
                    >
                      {{ record[column.id].values[row - 1].value }}
                    </div>
                  </td>
                </template>
              </template>
            </tr>
          </template>
          <tr
            v-if="data.actions"
            :style="{ height: data.type === 'main-factors' ? '34px' : '' }"
            class="c-table__record"
          >
            <th class="c-table__column" :rowspan="levels">
              <div class="c-table__column-empty c-table__column-empty-mobile"></div>
            </th>
            <td
              v-for="(record, recordIndex) in sortedRecords"
              :key="`${recordIndex}-sorted-record`"
              class="c-table__cell"
              :class="{ 'c-table__cell__border__none': sortedRecords.length - 1 === recordIndex }"
            >
              <c-table-main-factors-actions v-if="data.type === 'main-factors'" :record="record" />
              <c-table-finance-actions v-if="data.type === 'finance'" :record="record" />
              <c-table-inventory-items-actions v-if="data.type === 'inventory-items-positions'" :record="record" />
            </td>
          </tr>
        </table>
      </div>

      <perfect-scrollbar
        :id="'tableMobileScroll' + id"
        :options="{ useBothWheelAxes: false, suppressScrollX: false, suppressScrollY: true }"
        tag="div"
        class="c-table__container__mobile__scrolled__td"
        @scroll="setShadowTableMobile(id)"
      >
        <table ref="container">
          <template v-for="(column, recordIndex) in getColumns(data.levels)">
            <tr v-if="column.colspan === 1" :key="`${recordIndex}-mobile-record`" class="c-table__record">
              <th class="c-table__column c-table__column__mobile">
                <div
                  :class="{
                    'c-table__column-wrapper-mobile-main-factors': data.type === 'main-factors',
                    'c-table__column-wrapper-mobile-finance': data.type === 'finance',
                  }"
                  class="c-table__column-wrapper c-table__column-wrapper-mobile"
                >
                  <div class="c-table__column-label" :class="`c-table__column-label-${column.id}`">
                    {{ column.label }}
                  </div>
                </div>
              </th>
              <template v-for="(record, recordIndex) in sortedRecords">
                <td
                  :key="recordIndex"
                  class="c-table__cell"
                  :class="{
                    'c-table__cell__red':
                      (column.id === 'fotFromProceeds' || column.id === 'fotInCategory') && record[column.id] < 50,
                    'c-table__cell__green':
                      (column.id === 'fotFromProceeds' || column.id === 'fotInCategory') && record[column.id] > 50,
                  }"
                >
                  <c-table-load-cell v-if="column.id === 'load'" :record="record" />
                  <c-table-additional-load-cell v-else-if="column.id === 'additionalLoad'" :record="record" />
                  <c-table-lateness-cell v-else-if="column.id === 'lateness'" :calc-data="calcData" :record="record" />
                  <div v-else class="c-table__cell-value" v-html="record[column.id].value">
                    {{ record[column.id].value }}
                  </div>
                </td>
              </template>
            </tr>
            <tr v-for="(row, ind) in column.colspan" :key="`${recordIndex}-${ind}-mobile-record-col`" class="c-table__record">
              <template v-if="column.colspan > 1">
                <th v-if="ind === 0" :rowspan="column.colspan" class="c-table__column c-table__column__mobile">
                  <div class="c-table__column-wrapper">
                    <div class="c-table__column-label" :class="`c-table__column-label-${column.id}`">
                      {{ column.label }}
                    </div>
                  </div>
                </th>
                <template v-for="(record, recordIndex) in sortedRecords">
                  <td
                    v-if="record[column.id].values[row - 1].value"
                    :key="`${recordIndex}-mobile-record-col-record`"
                    :colspan="record[column.id].values[row - 1].rowspan"
                    class="c-table__cell"
                  >
                    <div
                      :class="{ 'c-table__cell-value-nowrap': data.type === 'main-factors' }"
                      class="c-table__cell-values"
                      v-html="record[column.id].values[row - 1].value"
                    >
                      {{ record[column.id].values[row - 1].value }}
                    </div>
                  </td>
                </template>
              </template>
            </tr>
          </template>
          <tr
            v-if="data.actions"
            :style="{ height: data.type === 'main-factors' ? '34px' : '' }"
            class="c-table__record"
          >
            <th class="c-table__column" :rowspan="levels">
              <div class="c-table__column-empty c-table__column-empty-mobile"></div>
            </th>
            <td
              v-for="(record, recordIndex) in sortedRecords"
              :key="`${recordIndex}-action-records`"
              class="c-table__cell"
            >
              <c-table-main-factors-actions v-if="data.type === 'main-factors'" :record="record" />
              <c-table-finance-actions v-if="data.type === 'finance'" :record="record" />
              <c-table-inventory-items-actions v-if="data.type === 'inventory-items-positions'" :record="record" />
            </td>
          </tr>
        </table>
      </perfect-scrollbar>
    </div>

    <div v-if="data.isGroupByCategory && data.records.length > 0" ref="container" class="c-table__container__mobile">
      <div v-for="(group, groupIndex) in sortedRecords" :key="`${groupIndex}-mobile-category`">
        <div
          v-b-toggle="`category-collapse-${id}${groupIndex}`"
          :class="{
            'c-table__cell__collapse__button__hide__borders': groupIndex === 0,
            'c-table__cell__collapse__button__hide__borders__last': sortedRecords.length === groupIndex + 1,
          }"
          class="c-table__cell__collapse__button d-flex align-items-center shadow-none"
        >
          <svg
            class="c-table__cell__collapse__button__icon"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="11" cy="11" r="10.5" fill="white" stroke="#D3D8DF" />
            <path
              d="M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z"
              fill="#0066FF"
            />
            <path
              d="M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z"
              fill="#0066FF"
            />
          </svg>
          <span class="c-table__cell__collapse__button__category__name">{{ group.categoryName }}</span>
          <span
            v-if="data.type === 'documents-acting-documents' || data.type === 'documents-archive'"
            class="c-table__cell__collapse__button__category__count"
          >
            {{ group.records.length }}
          </span>
        </div>

        <b-collapse :id="`category-collapse-${id}${groupIndex}`" class="c-table__mobile__collapse" visible>
          <div :id="'tableMobileFixed' + id + groupIndex" class="c-table__container__mobile__fixed__th">
            <table ref="container">
              <template v-for="(column, recordIndex) in getColumns(data.levels)">
                <tr v-if="column.colspan === 1" :key="`${recordIndex}-mobile-category-column`" class="c-table__record">
                  <th
                    :class="{
                      'c-table__column_sorted': isSorted(column),
                    }"
                    class="c-table__column c-table__column__mobile"
                  >
                    <div
                      class="c-table__column-wrapper c-table__column-wrapper-mobile"
                      @click="setSortedColumn(column, sortedColumn)"
                    >
                      <div class="c-table__column-label">
                        {{ column.label }}
                      </div>
                    </div>
                  </th>
                  <template v-for="(record, recordIndex) in sortedRecords[groupIndex].records">
                    <td :key="recordIndex" class="c-table__cell">
                      <div class="c-table__cell-value" v-html="record[column.id].value">
                        {{ record[column.id].value }}
                      </div>
                    </td>
                  </template>
                </tr>
                <tr v-for="(row, ind) in column.colspan" :key="`mobile-${ind}-column`" class="c-table__record">
                  <template v-if="column.colspan > 1">
                    <th v-if="ind === 0" :rowspan="column.colspan" class="c-table__column c-table__column__mobile">
                      <div class="c-table__column-wrapper">
                        <div class="c-table__column-label">
                          {{ column.label }}
                        </div>
                      </div>
                    </th>
                    <template v-for="(record, recordIndex) in sortedRecords[groupIndex].records">
                      <td
                        v-if="record[column.id].values[row - 1].value"
                        :key="`mobile-${ind}-column-${recordIndex}`"
                        :colspan="record[column.id].values[row - 1].rowspan"
                        class="c-table__cell"
                      >
                        <div class="c-table__cell-value">{{ record[column.id].values[row - 1].value }}</div>
                      </td>
                    </template>
                  </template>
                </tr>
              </template>
              <tr
                v-if="data.actions"
                :style="{ height: data.type === 'main-factors' ? '34px' : '' }"
                class="c-table__record"
              >
                <th class="c-table__column" :rowspan="levels">
                  <div class="c-table__column-empty c-table__column-empty-mobile"></div>
                </th>
                <td
                  v-for="(record, recordIndex) in sortedRecords[groupIndex].records"
                  :key="`action-${recordIndex}`"
                  class="c-table__cell"
                  :class="{ 'c-table__cell__move__in__company': data.type === 'move-in-company' }"
                >
                  <c-table-documents-actions
                    v-if="data.type === 'documents-acting-documents' || data.type === 'documents-archive'"
                    :record="record"
                    :record-id="`hidden-${groupIndex}-${recordIndex}`"
                    :table-type="data.type"
                  />
                </td>
              </tr>
            </table>
          </div>

          <perfect-scrollbar
            :id="'tableMobileScroll' + id + groupIndex"
            :options="{ useBothWheelAxes: false, suppressScrollX: false, suppressScrollY: true }"
            tag="div"
            class="c-table__container__mobile__scrolled__td"
            @scroll="setShadowTableMobile(id + groupIndex)"
          >
            <table ref="container">
              <template v-for="(column, recordIndex) in getColumns(data.levels)">
                <tr v-if="column.colspan === 1" :key="`${recordIndex}-column-${groupIndex}`" class="c-table__record">
                  <th class="c-table__column c-table__column__mobile">
                    <div class="c-table__column-wrapper c-table__column-wrapper-mobile">
                      <div class="c-table__column-label">
                        {{ column.label }}
                      </div>
                    </div>
                  </th>
                  <template v-for="(record, recordIndex) in sortedRecords[groupIndex].records">
                    <td :key="recordIndex" class="c-table__cell">
                      <div class="c-table__cell-value" v-html="record[column.id].value">
                        {{ record[column.id].value }}
                      </div>
                    </td>
                  </template>
                </tr>
                <tr v-for="(row, ind) in column.colspan" :key="`${ind}-column-${groupIndex}`" class="c-table__record">
                  <template v-if="column.colspan > 1">
                    <th v-if="ind === 0" :rowspan="column.colspan" class="c-table__column c-table__column__mobile">
                      <div class="c-table__column-wrapper">
                        <div class="c-table__column-label">
                          {{ column.label }}
                        </div>
                      </div>
                    </th>
                    <template v-for="(record, recordIndex) in sortedRecords[groupIndex].records">
                      <td
                        v-if="record[column.id].values[row - 1].value"
                        :key="`${recordIndex}-move-in-company`"
                        :colspan="record[column.id].values[row - 1].rowspan"
                        :class="{ 'c-table__cell__move__in__company': data.type === 'move-in-company' }"
                        class="c-table__cell"
                      >
                        <div class="c-table__cell-value">{{ record[column.id].values[row - 1].value }}</div>
                      </td>
                    </template>
                  </template>
                </tr>
              </template>
              <tr
                v-if="data.actions"
                :style="{ height: data.type === 'main-factors' ? '34px' : '' }"
                class="c-table__record"
              >
                <th class="c-table__column">
                  <div class="c-table__column-empty c-table__column-empty-mobile"></div>
                </th>
                <td
                  v-for="(record, recordIndex) in sortedRecords[groupIndex].records"
                  :key="`main-factors-${recordIndex}`"
                  class="c-table__cell"
                >
                  <c-table-documents-actions
                    v-if="data.type === 'documents-acting-documents' || data.type === 'documents-archive'"
                    :record-id="`mobile-${groupIndex}-${recordIndex}`"
                    :record="record"
                    :table-type="data.type"
                  />
                </td>
              </tr>
            </table>
          </perfect-scrollbar>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import MainFactorsActions from "@/pages/personal-employee/additions/data-table/main-factors-actions";
import FinanceActions from "@/pages/personal-employee/additions/data-table/finance-actions";
import InventoryItemsActions from "@/pages/personal-employee/additions/data-table/inventory-item-actions";
import DocumentsActions from "@/pages/personal-employee/additions/data-table/documents-actions";
import Button from "@/components/controls/button";

import DataTableLoadCell from "@/pages/calculations/create/additions/load-cell";
import DataTableAdditionalLoadCell from "@/pages/calculations/create/additions/additional-load-cell";
import DataTableLatenessCell from "@/pages/calculations/create/additions/lateness-cell";

export default {
  name: "data-table-create-calculation",

  components: {
    "c-button": Button,
    "c-table-main-factors-actions": MainFactorsActions,
    "c-table-finance-actions": FinanceActions,
    "c-table-inventory-items-actions": InventoryItemsActions,
    "c-table-documents-actions": DocumentsActions,

    "c-table-load-cell": DataTableLoadCell,
    "c-table-additional-load-cell": DataTableAdditionalLoadCell,
    "c-table-lateness-cell": DataTableLatenessCell,
  },

  props: [
    "id",
    "levels",
    "maxWidth",
    "data",
    "enabledFields",
    "disabledColumns",
    "sortedColumn",
    "filteredColumns",
    "activeFilteredColumns",
    "referenceList",
    "emptyRecordsLabel",
    "allGroups",
    "personalReasons",
    "calcData",
  ],

  data() {
    return {
      extremum: {},
      isScrolled: false,
      isScrollEnd: false,
      isScroll: false,
      positionTop: 0,
      filterFieldsBlockHeight: 0,
      filteredColumn: null,
      hideCollapseGroups: [],
      widthMobileTableBody: 0,
      isShowShadowMobileTableHeader: false,
      isShowShadowMobileTableHeaders: {},
    };
  },

  computed: {
    ...mapGetters("app", ["sidebarCollapsed"]),

    sortedRecords() {
      // if (!this.sortedColumn) {
      //   return this.data.records
      // }
      //
      // let sortedColumn = this.sortedColumn.sortBy
      // let sortType = (this.sortedColumn.sortType === 'asc') ? 1 : -1
      // let sortedColumns
      // let indexCol = this.data.columns.findIndex((col) => col.id === sortedColumn)
      // let typeCol = (this.data.columns[indexCol] !== undefined) ? this.data.columns[indexCol].type : undefined
      //
      // if (this.data.isGroupByCategory) {
      //   sortedColumns = this.data.records.map((group) => {
      //     return {
      //       categoryName: group.categoryName,
      //       records: group.records.sort(function (a, b) {
      //         if (a[sortedColumn] === undefined && b[sortedColumn] === undefined) {
      //           return 0
      //         }
      //
      //         if ((a[sortedColumn].value === undefined || a[sortedColumn].value === null) && (b[sortedColumn].value === undefined || b[sortedColumn].value === null)) {
      //           return 0
      //         }
      //
      //         if ((a[sortedColumn].value !== undefined && a[sortedColumn].value !== null) && (b[sortedColumn].value === undefined || b[sortedColumn].value === null)) {
      //           return 1 * sortType
      //         }
      //
      //         if ((a[sortedColumn].value === undefined || a[sortedColumn].value === null) && (b[sortedColumn].value !== undefined && b[sortedColumn].value !== null)) {
      //           return -1 * sortType
      //         }
      //
      //         if (typeCol === 'number') {
      //           return (a[sortedColumn].value - b[sortedColumn].value) * sortType
      //         }
      //
      //         if (a[sortedColumn].value.toLowerCase() < b[sortedColumn].value.toLowerCase()) {
      //           return -1 * sortType;
      //         } else if (a[sortedColumn].value > b[sortedColumn].value) {
      //           return 1 * sortType;
      //         } else {
      //           return 0;
      //         }
      //       })
      //     }
      //   })
      // } else {
      //   sortedColumns = this.data.records.sort(function (a, b) {
      //     if (a[sortedColumn] === undefined && b[sortedColumn] === undefined) {
      //       return 0
      //     }
      //
      //     if ((a[sortedColumn].value === undefined || a[sortedColumn].value === null) && (b[sortedColumn].value === undefined || b[sortedColumn].value === null)) {
      //       return 0
      //     }
      //
      //     if ((a[sortedColumn].value !== undefined && a[sortedColumn].value !== null) && (b[sortedColumn].value === undefined || b[sortedColumn].value === null)) {
      //       return 1 * sortType
      //     }
      //
      //     if ((a[sortedColumn].value === undefined || a[sortedColumn].value === null) && (b[sortedColumn].value !== undefined && b[sortedColumn].value !== null)) {
      //       return -1 * sortType
      //     }
      //
      //     if (typeCol === 'number') {
      //       return (a[sortedColumn].value - b[sortedColumn].value) * sortType
      //     }
      //
      //     if (a[sortedColumn].value.toLowerCase() < b[sortedColumn].value.toLowerCase()) {
      //       return -1 * sortType;
      //     } else if (a[sortedColumn].value > b[sortedColumn].value) {
      //       return 1 * sortType;
      //     } else {
      //       return 0;
      //     }
      //   })
      // }
      //
      // return sortedColumns
      return this.data.records;
    },
    shouldDisplayRecord() {
      return (
        (!(this.data.isGroupByCategory && this.data.records.length !== 0) ||
          !(this.data.isGroupByCategory && this.hideCollapseGroups.length === this.data.records.length)) &&
        this.data.records.length > 0
      );
    },
  },

  watch: {
    "enabledFields": function () {
      this.updatePositionTop();
    },

    "isScrollEnd": function () {
      // console.log('value: ', value)
    },

    "data.records": function (value) {
      this.countExtremums();
    },

    "disabledColumns": function (value) {
      const enabledColumns = this.data.columns.filter((item) => !value.includes(item.id));

      const max = Math.max.apply(
        null,
        enabledColumns.map((item) => item.level),
      );

      this.levels = max + 1;

      this.setTableShadow();
    },
  },

  mounted() {

    this.countExtremums();
    this.updatePositionTop();

    window.addEventListener("touchend", this.handleTouchMove, {
      passive: false,
    });
    document.querySelector(".layout").addEventListener("scroll", this.handleLayoutScroll);
    document.querySelector(".ps").addEventListener("scroll", this.handleTableScroll);

    if (this.$refs.wrapper) {
      this.isScroll = this.$refs.wrapper.$el.clientWidth < this.$refs.wrapper.$el.scrollWidth;
    }

    setTimeout(() => {
      this.setTableShadow();
    }, 1500);

    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (!isJustShown) {
        if (!this.hideCollapseGroups.includes(collapseId)) this.hideCollapseGroups.push(collapseId);
      } else {
        const c = this.hideCollapseGroups.indexOf(collapseId);
        if (c !== -1) this.hideCollapseGroups.splice(c, 1);
        this.setTableShadow();
      }
    });

    this.$emit("table-mounted");
  },

  methods: {
    countExtremums()
    {
      var proceedArr = [], fotArr = [], rateArr = [];

      this.data.records.forEach((r)=>{
        let k=r.postCode;
        if ((!k || k=="driver" || (k=="suhi" || k=="administrator" || k=="pizzamaker" || k=="European cook" || k=="Oficiant"  && (r.load && r.load.value>0))) &&  r.fotInCategory && r.fotInCategory.value!=0)
          fotArr.push(r.fotInCategory.value) ;
        if (r.fotFromProceeds && k && k!=='driver' && r.fotFromProceeds.value!=='') proceedArr.push(r.fotFromProceeds.value) ;
        if (r.productionRate && r.productionRate.value!=='') rateArr.push(r.productionRate.value) ;
      });

      this.extremum = {
        fotFromProceeds : proceedArr.length ? {min:Math.min.apply(Math,proceedArr), max:Math.max.apply(Math,proceedArr)} : null,
        productionRate : rateArr.length ? {min:Math.min.apply(Math,rateArr), max:Math.max.apply(Math,rateArr)} : null,
        fotInCategory : fotArr.length ? {min:Math.min.apply(Math,fotArr), max:Math.max.apply(Math,fotArr)} : null,
      }
     // console.log(this.extremum, proceedArr, fotArr, rateArr);
    },
    salmon(v) {
      this.$emit("salmon", v)
    },
    loadvalue(v) {
      this.$emit("loadvalue", v)
    },
    hexToRgb(hex) {
      return hex
        .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => `#${r}${r}${g}${g}${b}${b}`)
        .substring(1)
        .match(/.{2}/g)
        .map((x) => parseInt(x, 16));
    },
    parseRGB : function(rgb) {
      let comma1 = rgb.indexOf(', '),
        comma2 = rgb.indexOf(', ', comma1 + 1),
        red = rgb.slice('4', comma1),
        green = rgb.slice(comma1 + 2, comma2),
        blue = rgb.slice(comma2 + 2, -1)
      rgb = {red: red, green: green, blue: blue};
      return rgb;
    },

    findNextColor : function(start, end, num, i) {
      let red = this.findNext(this.parseRGB(start).red, this.parseRGB(end).red, num, i),
        green = this.findNext(this.parseRGB(start).green, this.parseRGB(end).green, num, i),
        blue = this.findNext(this.parseRGB(start).blue, this.parseRGB(end).blue, num, i);
      var rgb = `rgb(${red}, ${green}, ${blue})`;
      return rgb;
    },



    hexToRgb2 : function(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
      });
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      result = result ? {r: parseInt(result[1], 16),g: parseInt(result[2], 16),b: parseInt(result[3], 16)} : null;
      result = 'rgb('+result.r+', '+result.g+', '+result.b+')';
      return result;
    },

    findNext : function(start, end, num, i) {
      let calc,
        _start = parseInt(start),
        _end = parseInt(end),
        _num = parseInt(num),
        _i = parseInt(i),
        n_i = 2 * _i - 1;
      if (_end - _start == 0) {
        calc = _end;
      } else if (_end - _start > 0) {
        calc = _start + Math.round( ( (_end - _start) * n_i ) / (2 * _num) );
      } else {
        calc = _end + Math.round( ( (_start - _end) * (2 * _num - n_i) )/ (2 * _num) );
      }
      return calc;
    },

    calcColors : function(nomid, min, min_p, mid, mid_p, max, max_p, num) {
      //let colors = ['rgb(255,255,255)', 'rgb(127,127,127)', 'rgb(0,0,0)'];
      let colors = [];

      if (nomid) {
        if (num == '3') {
          colors = [min, mid, max];
        } else if (num > 3) {
          let grad = 100 / num;

          for (var i = 0; i < num; i++) {
            let left = Math.floor(min_p / grad) + 1,
              right = Math.floor((100 - max_p) / grad) + 1,
              new_num, center_pos, p_i, new_i;

            if (i < left) { // min
              colors.push(min);
            } else if (i >= (num - right)) {
              colors.push(max);
            } else if (num % 2 == 1) { // для нечетных градаций
              center_pos = Math.floor(mid_p / grad);
              p_i = i - left + 1;

              if (i == center_pos) { // mid
                colors.push(mid);
              } else if (i < center_pos) { // слева от середины
                new_num = center_pos - left;

                colors.push(this.findNextColor(min, mid, new_num, p_i));
              } else { // справа от середины
                new_num = num - center_pos - 1 - right;
                new_i = i - center_pos;

                colors.push(this.findNextColor(mid, max, new_num, new_i));
              }

            } else { // для четных градаций
              center_pos = Math.floor(mid_p / grad);
              p_i = i - left + 1;

              if (i < center_pos) { // слева от середины,
                new_num = center_pos - left;

                colors.push(this.findNextColor(min, mid, new_num, p_i));
              } else { // справа от середины
                new_num = num - center_pos - right;
                new_i = i - center_pos;

                colors.push(this.findNextColor(mid, max, new_num, new_i));
              }

            }
          }
        }

      } else {

        //есть min, max

        if (num == '2') {
          colors = [min, max];
        } else if (num > 2) {
          let grad = 100 / num,
            left = Math.floor(min_p / grad) + 1,
            right = Math.floor((100 - max_p) / grad) + 1,
            new_num = num - left - right;

          for (var i = 0; i < num; i++) {
            if (i < left) {
              colors.push(min);
            } else if (i >= (num - right)) {
              colors.push(max);
            } else {
              let p_i = i - left + 1;
              colors.push(this.findNextColor(min, max, new_num, p_i));
            }
          }
        }

      }
      return colors;
    },

    getColorForPercentage(pct, id) {
     // console.log(this.extremum, pct, id);
      if (this.calcData !== null && this.calcData.color_settings && this.extremum[id]) {
        var kpi_param=pct,min_val=this.extremum[id].min,max_val=this.extremum[id].max;
        if (typeof kpi_param !== "number" ) return '';

        var param_color = '';

        let type =  'fot';
        var total_settings = this.calcData.color_settings[0];
        if (id=="productionRate") {
          type = "prod";
          total_settings = this.calcData.color_settings[1];
        }
        //if (type == 'fot')
        //  var total_settings = $.parseJSON($('#fot_color_settings').val());
        //else
        //  var total_settings = $.parseJSON($('#prod_color_settings').val());
        var min_v = total_settings.min_value;
        var mid_v = total_settings.middle_value;
        var max_v = total_settings.max_value;
        var n = total_settings.color_gradation;
        var min_color = this.hexToRgb2(total_settings.min_color);
        var mid_color = this.hexToRgb2(total_settings.middle_color);
        var max_color = this.hexToRgb2(total_settings.max_color);
        var scale_length = total_settings.scale_length;
        if (total_settings.scale_color != 'own') {
          min_v = min_val;
          max_v = max_val;
          n = 5;
          scale_length = 2;
        }
        if (scale_length == 3)
          var pattern_colors = this.calcColors(true, min_color, 0, mid_color, 50, max_color, 100, n);
        else
          var pattern_colors = this.calcColors(false, min_color, 0, mid_color, 50, max_color, 100, n);

        if (scale_length == 2) {
          var step = (max_v - min_v)/n;
          step = step.toFixed(1);
          step = parseFloat(step);
        } else {
          var step1 = (mid_v - min_v)/(n/2);
          step1 = step1.toFixed(1);
          step1 = parseFloat(step1);
          var step2 = (max_v - mid_v)/(n/2);
          step2 = step2.toFixed(1);
          step2 = parseFloat(step2);
          //console.log('step1: '+step1+' step2: '+step2);
          step = step1;
        }
        //console.log('step: '+step);
        kpi_param = kpi_param ? kpi_param.toFixed(1) : 'none';
        if (kpi_param == 'none' && type != 'fot')
          kpi_param = 0;
        //console.log('kpi_param: '+kpi_param);
        if (kpi_param != 'none') {
          var start = parseFloat(min_v);
          start = start.toFixed(1);
          start = parseFloat(start);
          for (var i=1; i<=n; i++) {
            start = parseFloat(start);
            if (scale_length == 3 && start > mid_v) {
              step = step2;
            }
            var finish = start+step;
            finish = parseFloat(finish);
            finish = finish.toFixed(1);
            finish = parseFloat(finish);
            if (scale_length == 3 && finish > mid_v && step == step1) {
              step = (step1/2)+(step2/2);
              finish = start+step;
              finish = parseFloat(finish);
              finish = finish.toFixed(1);
              finish = parseFloat(finish);
            }
            //console.log('диапазон: '+start+' -- '+finish);
            if (kpi_param >= start && kpi_param < finish) {
              param_color = pattern_colors[i-1];
              //console.log('входит');
              //console.log('цвет: '+i);
              break;
            } else {

              start = finish;
            }
          }
          if (param_color == '') {
            kpi_param = parseFloat(kpi_param);
            min_v = parseFloat(min_v);
            if (kpi_param < min_v) {
              param_color = pattern_colors[0];
              var cvet = 0;
            }
            else {
              param_color = pattern_colors[n-1];
              var cvet = n-1;
            }

          }
        }
        return param_color;


        const mincolor = this.hexToRgb(this.calcData.color_settings[2].min_color);
        const middlecolor = this.hexToRgb(this.calcData.color_settings[2].middle_color);
        const maxcolor = this.hexToRgb(this.calcData.color_settings[2].max_color);
        const percentColors = [
          { pct: 0.0, color: { r: mincolor[0], g: mincolor[1], b: mincolor[2] } },
          { pct: 0.5, color: { r: middlecolor[0], g: middlecolor[1], b: middlecolor[2] } },
          { pct: 1.0, color: { r: maxcolor[0], g: maxcolor[1], b: maxcolor[2] } },
        ];
        let color = {};

        for (let i = 1; i < percentColors.length - 1; i++) {
          const lower = percentColors[i - 1];
          const upper = percentColors[i];
          const range = upper.pct - lower.pct;
          const rangePct = (pct - lower.pct) / range;
          const pctLower = 1 - rangePct;
          const pctUpper = rangePct;
          color = {
            r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
            g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
            b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper),
          };
          if (pct < percentColors[i].pct) {
            break;
          }
        }
        return `rgb(${[color.r, color.g, color.b].join(",")})`;
        // or output as hex if preferred
      }
      return "";
    },
    setShadowTableMobile(tableId) {
      const tableMobileFixed = document.getElementById(`tableMobileFixed${tableId}`);
      const tableMobileScroll = document.getElementById(`tableMobileScroll${tableId}`);
      if (tableMobileScroll.scrollLeft > 0) {
        tableMobileFixed.classList.add("c-table__container__mobile__fixed__th__shadow");
      } else {
        tableMobileFixed.classList.remove("c-table__container__mobile__fixed__th__shadow");
      }

      if (tableMobileScroll.scrollLeft < tableMobileScroll.scrollWidth - tableMobileScroll.clientWidth) {
        tableMobileScroll.parentElement.style.position = "relative";
        tableMobileScroll.parentElement.classList.add("c-table__container__mobile__scrolled__td__shadow");
      } else {
        tableMobileScroll.parentElement.classList.remove("c-table__container__mobile__scrolled__td__shadow");
      }
      //
    },

    handleTableScroll() {
      this.setTableShadow();
    },

    handleTouchMove() {
      // if (!e.cancelable) {
      //   e.preventDefault();
      //   return true
      // }
    },

    setTableShadow() {
      // if (this.data.actions === undefined) {
      //   return
      // }
      // const ps = document.querySelector('.ps');
      // const tableWrapper = document.querySelector('.c-table__wrapper');
      // const tableWrapperShadow = document.querySelector('.c-table__shadow');
      // const actionsBlock = document.getElementById('c-table-actions-element');
      //
      // if (!ps || !tableWrapperShadow) return
      //
      // let fullScrollWidth = ps.scrollWidth - ps.clientWidth;
      //
      // let diff = Math.abs(ps.scrollLeft - fullScrollWidth);
      //
      // if (diff > 0 && this.data.records.length !== 0) {
      //   tableWrapperShadow.classList.add('c-table__shadow_active');
      //   actionsBlock.classList.add('c-table__column_actions_shadow');
      // } else {
      //   tableWrapperShadow.classList.remove('c-table__shadow_active');
      //   actionsBlock.classList.remove('c-table__column_actions_shadow');
      // }
    },

    resetColumnFilters() {
      this.activeFilteredColumns = [];

      this.$refs.columnFilters.resetFilters();
    },

    isColumnFiltered(columnId) {
      if (this.filteredColumns === undefined) {
        return false;
      }
      const result = this.filteredColumns.findIndex((i) => i === columnId);

      return result !== -1;
    },

    isColumnActiveFiltered(columnId) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === columnId);

      return c !== -1;
    },

    setColumnFilter(e) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === e.id);

      const filterOptions = {
        id: e.id,
        type: e.type,
        searchType: e.filter.condition.value,
        value: e.type === "number" && e.filter.condition.value === "4" ? e.filter.rangeValue : e.filter.value,
      };

      if (
        c === -1 &&
        (filterOptions.type === "string" || filterOptions.type === "number") &&
        filterOptions.value === ""
      ) {
        return;
      }

      if (
        c !== -1 &&
        (filterOptions.type === "string" || filterOptions.type === "number") &&
        filterOptions.value === ""
      ) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (
        c === -1 &&
        filterOptions.type === "number" &&
        filterOptions.searchType === "4" &&
        (filterOptions.value.end === "" || filterOptions.value.start === "")
      ) {
        return;
      }

      if (
        c !== -1 &&
        filterOptions.type === "number" &&
        filterOptions.searchType === "4" &&
        (filterOptions.value.end === "" || filterOptions.value.start === "")
      ) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (c === -1 && filterOptions.type === "list" && filterOptions.value.length === 0) {
        return;
      }

      if (c !== -1 && filterOptions.value.length === 0) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (c === -1) {
        this.activeFilteredColumns.push(filterOptions);
      } else {
        this.activeFilteredColumns.splice(c, 1);
        this.activeFilteredColumns[c] = filterOptions;
      }
    },

    isCategory(column) {
      return column.isCategory === 1;
    },

    isSorted(column) {
      return column.isSorted;
    },

    setSortedColumn(column, sortedColumn) {
      if (column.isCategory !== 1 && sortedColumn !== undefined) {
        const c = this.data.columns.findIndex((i) => i.id === sortedColumn.sortBy);

        if (c !== -1) {
          this.data.columns[c].isSorted = false;
        }

        column.isSorted = true;
        this.sortedColumn.sortBy = column.id;

        if (column.id === sortedColumn.sortBy) {
          this.sortedColumn.sortType = this.sortedColumn.sortType === "asc" ? "desc" : "asc";
        } else {
          this.sortedColumn.sortType = "asc";
        }

        this.$emit("sortedEvent", this.sortedColumn);
      }
    },

    removeColumnFilter(columnId) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === columnId);

      if (c !== -1) {
        this.activeFilteredColumns.splice(c, 1);
      }
    },

    openColumnFilterModal(column) {
      const c = this.filteredColumns.findIndex((i) => i === column.id);

      if (c !== -1) {
        this.filteredColumn = column;
      }
    },

    handleLayoutScroll() {
      // const layout = document.querySelector(".layout");
      // const app = document.querySelector(".app");
      //
      // let result = layout.scrollTop - this.positionTop;
      //
      // if (app.offsetWidth < 992) {
      //   result += 50;
      // }
      // if (layout.scrollTop > this.positionTop) {
      //   if (this.$refs.header && (this.data.type !== 'inventory-items-history' && this.data.type !== 'inventory-items-positions')) {
      //     this.$refs.header.classList.add('c-table__header-shadow')
      //     this.$refs.header.style.transform = `translateY(${result}px)`;
      //   }
      // } else {
      //   if (this.$refs.header) {
      //     this.$refs.header.classList.remove('c-table__header-shadow')
      //     this.$refs.header.style.transform = 'none';
      //   }
      // }
    },

    updatePositionTop() {
      if (this.$refs.header !== undefined) {
        const header = this.$refs.header.getBoundingClientRect();
        const layout = document.querySelector(".layout");
        this.positionTop = header.top + layout.scrollTop;
      }
    },

    isDefaultCell(record, column) {
      return !this.disabledColumns.includes(column.id);
    },

    getChildrens(columnId) {
      return this.data.columns.filter((item) => item.parentColumnId === columnId);
    },

    getTableColumns(level) {
      let out = [];

      const columns = this.data.columns.filter((item) => item.parentColumnId === undefined);

      if (level === 1) {
        out = out.concat(columns);
      } else if (level === 2) {
        Object.keys(columns).forEach((i) => {
          out = out.concat(this.getChildrens(columns[i].id));
        });
      } else if (level === 3) {
        Object.keys(columns).forEach((i) => {
          const childrens = this.getChildrens(columns[i].id);

          Object.keys(childrens).forEach((ii) => {
            out = out.concat(this.getChildrens(childrens[ii].id));
          });
        });
      }

      return out;
    },

    getColumns(level) {
      let cols = [];

      if (level === 1) {
        cols = this.data.columns.filter((col) => col.parentColumnId === undefined);
      } else if (level === 2) {
        const rootCols = this.data.columns.filter((col) => col.parentColumnId === undefined);

        Object.keys(rootCols).forEach((i) => {
          const rootCol = rootCols[i];

          const childrens = this.data.columns.filter((col) => col.parentColumnId === rootCol.id);

          cols = cols.concat(childrens);
        });
      } else if (level === 3) {
        const rootCols = this.data.columns.filter((col) => col.parentColumnId === undefined);

        Object.keys(rootCols).forEach((i) => {
          const rootCol = rootCols[i];

          const childrens = this.data.columns.filter((col) => col.parentColumnId === rootCol.id);

          Object.keys(childrens).forEach((ii) => {
            const childrens2 = this.data.columns.filter((col) => col.parentColumnId === childrens[ii].id);
            cols = cols.concat(childrens2);
          });
        });
      }

      return cols;
    },

    getColspan(column) {
      const children = this.data.columns.filter((col) => col.parentColumnId === column.id);

      let count = children.length;

      if (column.level === 0) {
        Object.keys(children).forEach((c) => {
          const childrenChildren = this.data.columns
            .filter((col) => col.parentColumnId === children[c].id)
            .filter((colChild) => !this.disabledColumns.includes(colChild.id));

          count += childrenChildren.length;
        });
      }

      Object.keys(children).forEach((i) => {
        const result = this.disabledColumns.find((item) => item === children[i].id || children[i].isCategory === 1);

        if (result) {
          count -= 1;
        }
      });

      return count;
    },

    getRowspan(column) {
      const children = this.data.columns.filter((col) => col.parentColumnId === column.id);

      if (this.levels === 3) {
        if (column.level === 0 && children.length === 0) {
          return 3;
        }
        if (column.level === 1 && children.length === 0) {
          return 2;
        }
      } else if (this.levels === 2) {
        if (column.level === 0 && children.length === 0) {
          return 2;
        }
      }

      return 1;
    },

    getSeletItemLabel(record, column) {
      let cell = null;

      if (column.items) {
        const item = column.items.find((i) => i.value === record[column.name]);

        cell = item ? item.label : "-";
      } else {
        cell = "-";
      }

      return cell;
    },

    scroll() {
      // const layout = document.querySelector(".layout");
      // layout.classList.add('layout-touch-action-none');
      const wrapper = this.$refs.wrapper.$el;
      this.isScrolled = this.$refs.wrapper.$el.scrollLeft > 0;
      const containerWidth = this.$refs.container.offsetWidth;
      const wrapperWidth = this.$refs.wrapper.$el.offsetWidth;
      const { scrollLeft } = this.$refs.wrapper.$el;
      this.isScrollEnd = wrapperWidth + scrollLeft >= wrapper.scrollWidth && wrapper.scrollWidth > containerWidth;
      // layout.classList.remove('layout-touch-action-none');
    },

    isDisabled(id) {
      return this.disabledColumns.find((item) => item === id);
    },

    getReferenceValues(e) {
      this.$emit("getReferenceValues", e);
    },

    getCountWorkers(postCode) {
      let countWorkers;
      this.allGroups.forEach((group) => {
        group.categories.forEach((category) => {
          const c = category.posts.findIndex((post) => post.code === postCode);
          if (c !== -1) {
            countWorkers = category.posts[c].countWorkers;
          }
        });
      });
      return countWorkers;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-table {
  position: relative;
  display: inline-block;
  max-width: 100%;

  &__record {
    &:focus {
      outline: none;
    }
    &[aria-expanded="true"] .c-table__cell__collapse__button svg {
      transform: rotate(-180deg);
    }
    &[aria-expanded="false"] .c-table__cell__collapse__button {
      border-bottom: none;
    }

    &__red {
      background: #ffe6f2;
    }

    &__yellow {
      background: #fdffb3;
    }

    &__grey {
      background: #f5f7fa;
    }
  }

  &__scrollbar-wrapper {
    position: fixed;
    height: 24px;
    background: white;
    box-shadow: $box-shadow;
    bottom: 0;
    left: 0;
    z-index: 100;
    transition: 0.2s;

    @media screen and (max-width: 992px) {
      display: none;
    }
  }

  @media screen and (max-width: 992px) {
    max-width: 100%;
  }

  @media screen and (max-width: 700px) {
    margin: 0 -20px;
    width: calc(100% + 40px);
    max-width: none;
  }

  &__wrapper {
    overflow-x: auto;
    position: relative;
    transition: 0.2s;
    display: inline-block;
    width: 100%;

    &__mobile {
      margin-top: 1px;
      margin-left: -1px;
    }

    &::-webkit-scrollbar {
      height: 0;
    }

    @media screen and (max-width: 992px) {
      width: 100%;
    }

    ::v-deep & .ps__rail-y {
      display: none !important;
    }

    ::v-deep & .ps__rail-x {
      z-index: 351;
      background: #ffffff !important;
    }

    ::v-deep & .ps__rail-x:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-30px, 0);
      box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
      z-index: -1;
      height: 24px;
      width: calc(100vw - 60px);
      background: #ffffff;
    }

    ::v-deep & .ps__rail-x:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(0, calc(-50% + 1px));
      border-radius: 10px;
      z-index: -1;
      height: 4px;
      width: calc(100% - 34px);
      background: #dfe4ef;
    }
  }

  &__shadow {
    position: absolute;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
    width: 10px;
    height: calc(100% - 10px);
    right: 66px;
    opacity: 0;
    bottom: 10px;
    visibility: hidden;
    z-index: 83;
    transition: 0.2s;

    @media screen and (max-width: 700px) {
      background: transparent;
    }

    &__finance {
      right: 40px;
    }

    &__inventory-items-positions {
      right: 166px;
    }

    &__documents {
      right: 100px;
    }
  }

  &__empty__shadow {
    right: 0;
  }

  &__empty__records {
    border: 1px solid $color-border-alt;
    width: calc(100% - 1px);
    height: 40px;
    display: flex;
    margin-top: -8px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: $z-index-loader;
    background: white;
    color: $label;
    font-size: 13px;

    @media screen and (max-width: 700px) {
      width: 100%;
      height: 200px;
      border-left: none;
      border-right: none;
      margin-top: 0;
    }
  }

  &__empty__posts__not__added {
    font-size: 15px;

    @media screen and (max-width: 700px) {
      margin: 0 20px;
    }
  }

  &__shadow_active {
    opacity: 0.15;
    visibility: visible;
  }

  &_scroll {
    .c-table__column_actions {
      &:after {
        visibility: visible !important;
        opacity: 0.15 !important;
      }
    }

    &.c-table_scroll_end {
      .c-table__shadow {
        visibility: hidden;
        opacity: 0;
      }

      .c-table__column_actions {
        &:after {
          visibility: hidden !important;
          opacity: 0 !important;
        }
      }
    }
  }

  &_scrolled {
    border-left: 1px solid $color-border-light;

    //@media screen and (max-width:992px) {
    border-left: none;

    &:before {
      position: absolute;
      content: "";
      width: 22px;
      pointer-events: none;
      height: 100%;
      background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
      top: 0;
      left: 0;
      z-index: 100;
    }
    //}
  }

  &_scrolled_right {
    border-left: 1px solid $color-border-light;

    //@media screen and (max-width: 992px) {
    border-left: none;

    &:after {
      position: absolute;
      content: "";
      width: 22px;
      pointer-events: none;
      height: 100%;
      background: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
      top: 0;
      right: 0;
      z-index: 100;
    }
    //}
  }

  .c-table {
    &__container {
      border-collapse: collapse;
      width: calc(100% - 1px);

      @media screen and (max-width: 700px) {
        display: none;
      }

      &__mobile {
        display: none;
        position: relative;

        @media screen and (max-width: 700px) {
          display: block;
        }

        &__fixed__th td,
        &__fixed__th th,
        &__scrolled__td td,
        &__scrolled__td th {
          background: white;
        }

        &__fixed__th {
          position: absolute;
          & table {
            margin-left: -1px;
          }

          &__shadow {
            &:after {
              content: "";
              position: absolute;
              top: 0;
              left: 82px;
              height: 100%;
              z-index: 10;
              background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
              opacity: 0.15;
              transform: rotate(-180deg);
              width: 10px;
            }
          }
        }

        &__fixed__th th {
          position: relative;
          z-index: 1;
        }

        &__scrolled__td {
          &__shadow {
            &:after {
              position: absolute;
              width: 22px;
              height: 100%;
              pointer-events: none;
              z-index: 1000;
              top: 0;
              right: -1px;
              content: "";
              background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
            }
          }

          & table {
            min-width: 100%;
            margin-left: -2px;
          }
          //display: inline-block;
        }

        &__scrolled__td td {
          position: relative;
        }
      }
    }

    &__header {
      border-bottom: 2px solid $color-border-light;
      position: relative;
      background: $color-border-light;
      z-index: 82;

      &__mobile {
        display: inline-block;
        width: calc(100% - 1px);
        position: relative;

        &__shadow {
          &:after {
            content: "";
            position: absolute;
            height: 100%;
            top: 0;
            z-index: 100;
            right: -10px;
            width: 10px;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
            opacity: 0.15;
            transform: rotate(-180deg);
          }
        }
      }
    }

    &__header-shadow:after {
      content: "";
      position: absolute;
      background: linear-gradient(#001550, rgba(255, 255, 255, 0));
      width: 100%;
      height: 10px;
      opacity: 0.15;
      z-index: 69;
      bottom: -10px;
      left: 0;
    }

    &__column {
      text-align: left;
      border: 1px solid $color-border-light;
      vertical-align: top;
      height: 1px;
      padding: 0;
      transition: 0.2s;

      &_hidden {
        width: 0;
        border: none;
        overflow: hidden;
        display: none;
        // margin-left: -1px;

        .c-table__column-wrapper {
          width: 0;
          padding: 0;
          border: none;
        }
      }

      &_with {
        &_filter {
          .c-table__column {
            &-wrapper {
              flex-direction: column;
            }

            &-actions {
              margin-top: 10px;
            }
          }
        }
      }

      &_sorted {
        .c-table__column-label {
          color: $color-primary;
        }
      }

      &-label {
        color: $color-label;
        font: {
          size: 12px;
          weight: 500;
        }
        line-height: 13px;

        &-event {
          white-space: nowrap;
        }

        &-mobile {
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &-children {
          cursor: pointer;
        }
      }

      &-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 11px;
        height: 100%;
        background: white;

        &-mobile {
          max-width: 83px;
          border-right: 1px solid #dfe4ef;

          & .c-table__column-label {
            display: flex;
            align-items: center;
          }

          &-main-factors {
            padding: 8.5px !important;
          }

          &-finance {
            padding: 8.5px !important;
          }
        }

        @media screen and (max-width: 700px) {
          padding: 10px;
        }
      }

      &-actions {
        display: flex;
        justify-content: space-between;
      }

      &-action {
        width: 14px;
        height: 14px;

        .c-button {
          width: 14px;
          height: 14px;
        }

        &_description {
          margin-left: -3px;
        }
      }

      &_actions {
        position: sticky;
        right: 0;
        border-right: none;
        z-index: 30;

        @media screen and (max-width: 700px) {
          border-right: solid 1px $color-border-light;
        }

        &_shadow {
          &:after {
            content: "";
            position: absolute;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
            width: 9px;
            height: 100%;
            left: -8px;
            opacity: 0;
            bottom: 0;
            visibility: hidden;
            z-index: 40;
          }
        }
      }

      &-empty {
        background: white;
        width: calc(100% + 1px);
        height: calc(100% + 2px);
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        border-bottom: 2px solid $color-border-light;
        margin-left: -1px;
        position: relative;

        &-mobile {
          height: calc(100% + 1px);
          border-bottom: 1px solid $color-border-light;
        }
      }

      &__mobile {
        width: 83px;
        min-width: 83px;
        border-right: none;
        overflow-wrap: normal !important;
        //word-break: break-all !important;
      }
    }

    &__cell {
      border: 1px solid $color-border-light;
      padding: 0;
      height: 1px;
      //transition: .2s;

      &__red {
        background: #ffe6f2 !important;
      }

      &__green {
        background: #d0f4e3;
      }

      &__yellow {
        background: #fdffb3 !important;
      }

      &__move__in__company {
        min-width: 200px;
      }

      &__border__none {
        border: none !important;
      }

      &_post {
        white-space: nowrap !important;
      }

      &_payments {
        background: #e1edff !important;
      }

      &_double_top_border {
        border-top: 2px solid $color-border-light;
      }

      &_minShiftDuration {
        text-align: right;
      }

      &_loadType {
        text-align: right;
      }

      &_finesPerShift,
      &_rewardsShift {
        text-align: center;
      }

      &_change {
        & .c-table__cell-value {
          white-space: nowrap;
        }
      }

      &_vertical_align {
        &:first-child {
          vertical-align: top;
        }
      }

      &__collapse__button {
        height: 38px;
        vertical-align: middle;
        padding: 0 10px;
        white-space: nowrap;
        background: #f5f7fa;
        overflow: hidden;
        position: relative;
        outline: none;
        border: 1px solid #dfe4ef;
        z-index: 81;
        font-family: Fira Sans;
        font-weight: bold;
        font-size: 13px;
        color: #000000;

        &__docs {
          border-right: 0;

          &:after {
            content: "";
            height: 100%;
            width: 1px;
            background: #dfe4ef;
            position: absolute;
            top: 0;
            right: 0;

            @media screen and (max-width: 700px) {
              display: none;
            }
          }
        }

        @media screen and (max-width: 700px) {
          &[aria-expanded="true"] svg {
            transform: rotate(-180deg);
          }
          &__hide__borders {
            &[aria-expanded="true"] {
              border-bottom: none;
            }
            &[aria-expanded="false"] {
              border-bottom: solid 1px $color-border-light !important;
            }
          }
          &__hide__borders__last {
            border-top: none;
            &[aria-expanded="true"] {
              border-bottom: none !important;
            }
            &[aria-expanded="false"] {
              border-bottom: solid 1px $color-border-light !important;
            }
          }
          border-right: none;
          border-left: none;
        }

        &__icon {
          margin-right: 10px;
        }

        &__category__name {
          line-height: 38px;
        }

        &__category__count {
          line-height: 38px;
          margin-left: 6px;
          color: #8e9cbb;

          @media screen and (max-width: 700px) {
            margin-right: 2px;
          }
        }

        &__button {
          vertical-align: middle;
          display: inline-block;
          margin-left: 3px;
        }

        @media screen and (max-width: 767px) {
          &__border__right {
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            width: 1px;
            background: #dfe4ef;
          }
        }
      }

      &_number {
        & .c-table__cell-value {
          text-align: right;
        }
      }

      &_rank {
        & .c-table__cell-value {
          text-align: left;
        }
      }

      &_hidden {
        width: 0;
        overflow: hidden;
        border: none;
        display: none;

        .c-table__cell-value,
        .c-table__cell-cell {
          width: 0;
          padding: 0;
        }
      }

      &-cell {
        display: flex;
        align-items: center;
        transition: 0.2s;
      }

      &-value {
        line-height: 13px;
        font-size: 13px;
        padding: 10px !important;
        transition: font 0.3s ease;

        &-nowrap {
          white-space: nowrap !important;
        }
      }

      &-values {
        padding: 0;
        line-height: 13px;
        font-size: 13px;
        transition: font 0.3s ease;
        white-space: nowrap !important;

        ::v-deep & .c-table__cell-values-value {
          background: red;
        }
      }

      &-pre-formatted {
        white-space: pre;
      }

      &_actions {
        position: sticky;
        right: 0;
        border-right: none;
        z-index: 20;

        @media screen and (max-width: 700px) {
          position: static;
        }
      }

      &-actions {
        background: white;
        width: calc(100% + 1px);
        min-height: 30px;
        height: 100%;
        display: flex;
        align-items: center;
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        margin-left: -1px;

        &-collapse-button {
          border-left: 0;
        }
      }
    }
  }
}

::v-deep .collapsing {
  transition: font 0.5s ease;
}

::v-deep .collapse {
  display: table-row !important;
}

::v-deep .collapse.c-table__mobile__collapse {
  display: block !important;
}

::v-deep .collapsed ~ .collapse {
  max-height: 0 !important;

  & .c-table__cell {
    border: 0 !important;
    height: 0 !important;
    max-height: 0 !important;
  }

  & .c-table__cell .inventory-item-actions {
    display: none !important;
  }

  & .c-table__cell .documents-files-cell {
    display: none !important;
  }

  & .c-table__column {
    border: 0 !important;
    height: 0 !important;
    max-height: 0 !important;
  }

  & .c-table__column .c-table__column-wrapper {
    padding: 0 !important;
    border-right: 0 !important;
    max-height: 0 !important;
    height: 0 !important;
  }

  & .c-table__column .c-table__column-empty-mobile {
    border: none;
    max-height: 0 !important;
  }

  & .c-table__column .c-table__column-wrapper .c-table__column-label {
    font-size: 0 !important;
  }

  & .c-table__cell .c-table__cell-value {
    color: #ffffff !important;
    line-height: 0 !important;
    padding: 0 !important;
    font-size: 0;
    transition: font 0.3s ease;
  }

  & .c-table__cell .documents-actions {
    display: none;
  }

  & .c-table__cell .cell-filial-settings {
    visibility: hidden !important;
    height: 0 !important;
    max-height: 0 !important;
    padding: 0 !important;
    font-size: 0 !important;

    & .cell-filial-settings__value {
      font-size: 0;
      line-height: 0;
    }

    & .cell-filial-settings__icon {
      display: none;
    }
  }

  & .c-table__cell_actions .c-table__cell-actions {
    display: none;
  }

  & .c-table__header__mobile {
    max-height: 0 !important;
  }
  & .c-table__header__mobile tr {
    max-height: 0 !important;
  }

  & .c-table__header__mobile tr .c-table__column {
    border: 0 !important;
    height: 0 !important;
    font-size: 0 !important;
    max-height: 0 !important;
  }

  & .c-table__header__mobile tr .c-table__column .c-table__column-wrapper {
    display: none;
    padding: 0 !important;
  }

  & .c-table__header__mobile tr .c-table__column .c-table__column-label {
    font-size: 0 !important;
    line-height: 0 !important;
  }
}
</style>

<style lang="scss">
.c-table__cell-values {
  @media screen and (max-width: 700px) {
    display: flex;
  }
  &-value {
    padding: 10px;
    border-bottom: solid 1px #dfe4ef;

    @media screen and (max-width: 700px) {
      border-bottom: none;
      border-right: solid 1px #dfe4ef;
    }
  }
  &-value-not-border {
    padding: 10px;
  }
}
</style>
